import React, {useRef, useState} from 'react';
import Modal from "../../components/modal/modal";
import axiosInstance from "../../AxiosInstance";
import {BigTextInput, DangerButton, SelectInput} from "../../components/input/inputs";
import styles from "../../styles/main.module.css";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSave} from "@fortawesome/free-solid-svg-icons";
import {
    afterInvoiceActionSuccess,
    rejectFailedResponse,
} from "../bus/afterInvoiceActionSuccess";

export default function ObserveModal({show, setter, invoice}) {
    const [form, setForm] = useState({});
    const [dragActive, setDragActive] = useState(false);
    const fileInputRef = useRef(null);

    const options = [
        {id: 0, name: 'Guía de Remisión'},
        {id: 1, name: "Acta de Conformidad"},
        {id: 2, name: "Informe de servicio"},
        {id: 3, name: "Nota de Credito"}
    ];

    const setObservationFiles = (fileList) => {
        const selectedFiles = Array.from(fileList || []);
        setForm((prev) => ({
            ...prev,
            observation: selectedFiles,
        }));
    };

    const observe = () => {
        let formData = new FormData();
        for (const key in form) {
            if (key === 'observation') {
                const files = form[key];
                for (let i = 0; i < files.length; i++) {
                    formData.append(key, files[i]);
                }
            } else {
                formData.append(key, form[key]);
            }
        }
        formData.append("bill_id", invoice?.id);

        axiosInstance.post('observation/', formData).then(rejectFailedResponse).then(() => {
            afterInvoiceActionSuccess(setter);
        });
    };

    return (
        <Modal show={show} setter={setter} name={'Observar'} hideClose={true}>
            <SelectInput greyBackground={true} form={form} setForm={setForm} name={'Tipo de Documento:'} internalName={'document_type'} options={options}/>
            <div className={'mb-2'}/>
            <BigTextInput form={form} setForm={setForm} name={'Ingresar Observaciones:'} internalName={'text'}/>

            <div
                className={'mb-3 py-3 px-2'}
                style={{
                    border: dragActive ? '2px dashed #4A4DBB' : '2px dashed #ccc',
                    borderRadius: '8px',
                    textAlign: 'center',
                    cursor: 'pointer',
                    backgroundColor: dragActive ? 'rgba(74, 77, 187, 0.06)' : 'transparent',
                }}
                onDragOver={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setDragActive(true);
                }}
                onDragLeave={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setDragActive(false);
                }}
                onDrop={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setDragActive(false);
                    setObservationFiles(e.dataTransfer?.files);
                }}
                onClick={() => fileInputRef.current?.click()}
                role={'presentation'}
            >
                <input
                    ref={fileInputRef}
                    type={'file'}
                    accept={'.xml,.pdf,.zip'}
                    multiple={true}
                    style={{ display: 'none' }}
                    onChange={(event) => {
                        setObservationFiles(event.target.files);
                    }}
                />
                <div>Arrastre archivos aquí o haga clic para seleccionar (XML, PDF, ZIP)</div>
                {form.observation?.length > 0 && (
                    <div className={'mt-2 small'}>
                        {form.observation.map((f, i) => (
                            <div key={i}>{f.name}</div>
                        ))}
                    </div>
                )}
            </div>

            <div className={'d-flex justify-content-center align-items-center align-content-center mt-3'}>
                <div onClick={() => observe()} className={styles.modalButton} style={{backgroundColor: "#4A4DBB"}}>
                    <FontAwesomeIcon icon={faSave} className={'pe-2'}/> Guardar
                </div>
                <DangerButton onClick={() => setter(false)} name={'Cerrar'}/>
            </div>
        </Modal>
    )
}
